<template>
	<div>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
			<h1 class="h3 mb-0 text-gray-800">Números bloqueados</h1>
			<div>
				<button class="btn btn-sm btn-success" @click="add">Novo</button>
			</div>
	    </div>

	    <alert :type="alert.type" :mensagem="alert.msg" />
		<filtros :filter_data="filter_data" @filtrar="filtrar" />

		<div class="row">
			<table class="table table-striped table-hover table-sm table-responsive-xl">
				<thead align="center">
					<th @click="orderBy('id')"         >ID           <font-awesome-icon v-if="direction.by == 'id'"         :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('telefone')"   >TELEFONE     <font-awesome-icon v-if="direction.by == 'telefone'"   :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('descricao')"  >DESCRIÇÃO    <font-awesome-icon v-if="direction.by == 'descricao'"  :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('created_at')" >ADICIONADO EM<font-awesome-icon v-if="direction.by == 'created_at'" :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('updated_at')" >ALTERADO EM  <font-awesome-icon v-if="direction.by == 'updated_at'" :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('call_in')"    >BLOQUEIO     <font-awesome-icon v-if="direction.by == 'call_in'"    :icon="order_icon" size="xs" /></th>
					<th></th>
				</thead>
				
				<transition mode="out-in" name="leftIn">
					<tbody v-if="blacklist" align="center">
						<tr v-for="(phone, index) in blacklist.result.data" :key="index">
							<td>{{ phone.id }}</td>
							<td>{{ Phone(phone.telefone) }}</td>
							<td>{{ phone.descricao }}</td>
							<td>{{ phone.created_at | moment("DD/MM/YYYY") }}</td>
							<td>{{ phone.updated_at | moment("DD/MM/YYYY") }}</td>
							<td><font-awesome-icon :icon="phone.call_in  == 1 ? 'lock' : 'unlock'" class="pointer" :class="phone.call_in  == 1 ? 'vermelho' : 'verde'" @click="toggle_block(phone, 'call_in')"  /></td>
							<td><font-awesome-icon icon="eye" class="info pointer" @click="view(phone)" /></td>
						</tr>
					</tbody>
					<Loading v-else />
				</transition>
			</table>
		</div>

	    <controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
        <modal :estado="modal_data" @alert="show_alert" />
	</div>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import alert    from "@/components/Tools/alert.vue"
	import filtros  from "@/components/Tools/Filtro.vue"
	import controls from "@/components/Tools/Table_Control.vue"
	import modal    from "@/components/Modal/Views/Blacklist.vue"

	export default {
		name: "Blacklist",
		mixins: [api, replace],
		components: { controls, filtros, alert, modal },

		data() { return {
			blacklist: null,
			constrol_data: {},
			modal_data: {},

			alert: { type: "", msg: "" },
			direction: { order: "desc", by: "id" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{ name: "id",         label: "ID",       type: "text",  data_get: ""},
				{ name: "created_at", label: "Data",     type: "date",  data_get: ""},
				{ name: "telefone" ,  label: "Telefone", type: "phone", data_get: ""}
			],
			data_head: ["ID", "TELEFONE", "DESCRIÇÃO", "ADICIONADO EM", "ALTERADO EM", "BLOQUEIO"],
			data_body: ["id", "telefone", "descricao", "data", "updated", "call_in"]
		}},

		created() {
			this.get_data()
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			}
		},

		methods: {
			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload

				this.get_data()
			},

			filtrar(payload) {
				this.string_filter = payload
				this.get_data()
			},

			async get_data() {
				this.blacklist = null
				this.blacklist = await this.GET("Blacklist", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`)

				this.constrol_data = {
					current_page: this.blacklist.result.current_page,
					last_page:    this.blacklist.result.last_page,
					per_page:     this.blacklist.result.per_page,
					total:        this.blacklist.result.total,
				}
            },
            
            toggle_block(payload, index) {
                switch (index) {
                    case 'denuncia':
                        payload.denuncia = (payload.denuncia == 0) ? 1 : 0
                        break

                    case 'call_in':
                        payload.call_in = (payload.call_in == 0) ? 1 : 0
                        break

                    case 'call_out':
                        payload.call_out = (payload.call_out == 0) ? 1 : 0
                        break
                }

                this.PUT("Blacklist", payload)
            },

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			add() {
                this.modal_data = {
                    telefone: '',
                    descricao: '',
                    denuncia: 0,
                    call_in:  0,
                    call_out: 0
                }
                
				$("#modal-blacklist").modal()
			},

			view(payload) {
				this.modal_data = payload
				$("#modal-blacklist").modal()
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger"
				this.alert.msg  = payload.result

				$("#modal-blacklist").modal('hide')
				this.get_data()
				$("#app-alert").show()
				setTimeout(() => $("#app-alert").hide(), 3000 )
			},

			icon_if_block(payload) {
				return ( payload == 1 ) ? "Bloqueado" : ""
			},
		},
	}
</script>

<style>
	
</style>